import {
  useCallback,
  useEffect,
  useState,
} from 'react';

import { Contract } from 'ethers';

const useLpTotalSupply = (lpContract: Contract | null,) => {
    const [totalSupply, setTotalSupply] = useState(BigInt(0)); // LP 总供应量
    const [totalSupplyLod, setLoading] = useState(false); // 加载状态
    const getTotalSupply = useCallback(async () => {
        if (lpContract) {
            try {
                setLoading(true); // 设置加载状态为 true
                // 获取 LP 合约的总供应量
                const supply = await lpContract.totalSupply();
                setTotalSupply(supply); // 更新总供应量状态
            } catch (e) {
                console.log('useLpTotalSupply', e); // 捕获并打印错误
            } finally {
                setLoading(false); // 无论成功或失败，重置加载状态
            }
        } else {
            setTotalSupply(BigInt(0)); // 如果 lpContract 为 null，重置总供应量
        }
    }, [lpContract]);
    useEffect(() => {
        getTotalSupply()
    }, [getTotalSupply])
    return { totalSupply, totalSupplyLod }
}

export default useLpTotalSupply